import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";

//Components
import ProgressBar from "../../../components/ProgressBar/StepperProgress";
import Identificacao from "../../../views/Shared/Gerador/Identificacao";
import GeradorObra from "../../../views/Shared/GeradorPGRCC/GeradorObra";
import ExecutorObra from "../../../views/Shared/GeradorPGRCC/ExecutorObra";
import DadosObra from "../../../views/Shared/GeradorPGRCC/DadosObra";
import PlanoResiduoModelo from "../../../views/Shared/GeradorPGRCC/PlanoResiduoModelo";
import PlanoResiduoDetalhamento from "../../../views/Shared/GeradorPGRCC/PlanoResiduoDetalhamento";
import TransportadoresPGRCC from "../../../views/Shared/GeradorPGRCC/TransportadoresPGRCC";
import DestinoPGRCC from "../../../views/Shared/GeradorPGRCC/DestinoPGRCC";
import InformacoesComplementares from "../../../views/Shared/GeradorPGRCC/InformacoesComplementares";
import Documentos from "../../../views/Shared/Documentos";

export default function ManutencaoGeradorPGRCCForm({
  item,
  handleReturn,
  setupSolicitacao,
  addNovoGerador = false,
}) {
  const [protocolo, set_protocolo] = useState(item);

  const steps = [
    "Gestor do PGRCC",
    "Gerador da Obra",
    "Executor da Obra",
    "Dados da Obra",
    "Plano de Resíduos - Modelo",
    "Plano de Resíduos - Detalhamento",
    "Transportadores",
    "Destinos",
    "Informações Complementares",
    "Documentos",
  ];
  const [step, set_step] = useState(0);

  const [opcao, set_opcao] = useState({
    tipoCadastro: "Protocolo",
    segmento: "Grande Gerador",
    categoria: { sigla: "RSS" },
  });

  useEffect(() => {
    set_opcao({
      tipoCadastro: "Protocolo",
      segmento: "Grande Gerador - PGRCC",
      categoria:
        item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria,
    });
    set_protocolo(item);
  }, [item]);

  const handleProximoStep = (_protocolo) => {
    if (step === 9) handleReturn();
    else {
      set_protocolo(_protocolo);
      set_step(step + 1);
    }
  };
  const handleStepAnterior = (_protocolo) => {
    set_protocolo(_protocolo);
    set_step(step - 1);
  };

  return (
    <>
      <div className="content">
        <Container className="text-center">
          <ProgressBar stepValue={step} steps={steps} />
        </Container>

        {step === 0 && (
          <Identificacao
            item={protocolo}
            opcao={opcao}
            permiteManutencao={true}
            handleProximoStep={handleProximoStep}
            handleReturn={handleReturn}
            addNovoGerador={addNovoGerador}
            setupSolicitacao={setupSolicitacao}
          />
        )}

        {step === 1 && (
          <GeradorObra
            item={protocolo}
            setItem={set_protocolo}
            opcao={opcao}
            handleProximoStep={handleProximoStep}
            handleStepAnterior={handleStepAnterior}
          />
        )}

        {step === 2 && (
          <ExecutorObra
            item={protocolo}
            setItem={set_protocolo}
            opcao={opcao}
            handleProximoStep={handleProximoStep}
            handleStepAnterior={handleStepAnterior}
          />
        )}

        {step === 3 && (
          <DadosObra
            item={protocolo}
            setItem={set_protocolo}
            opcao={opcao}
            handleProximoStep={handleProximoStep}
            handleStepAnterior={handleStepAnterior}
          />
        )}

        {step === 4 && (
          <PlanoResiduoModelo
            item={protocolo}
            setItem={set_protocolo}
            opcao={opcao}
            handleProximoStep={handleProximoStep}
            handleStepAnterior={handleStepAnterior}
          />
        )}

        {step === 5 && (
          <PlanoResiduoDetalhamento
            item={protocolo}
            setItem={set_protocolo}
            opcao={opcao}
            handleProximoStep={handleProximoStep}
            handleStepAnterior={handleStepAnterior}
          />
        )}

        {step === 6 && (
          <TransportadoresPGRCC
            item={protocolo}
            setItem={set_protocolo}
            opcao={opcao}
            handleProximoStep={handleProximoStep}
            handleStepAnterior={handleStepAnterior}
          />
        )}

        {step === 7 && (
          <DestinoPGRCC
            item={protocolo}
            setItem={set_protocolo}
            opcao={opcao}
            handleProximoStep={handleProximoStep}
            handleStepAnterior={handleStepAnterior}
          />
        )}

        {step === 8 && (
          <InformacoesComplementares
            item={protocolo}
            setItem={set_protocolo}
            opcao={opcao}
            handleProximoStep={handleProximoStep}
            handleStepAnterior={handleStepAnterior}
          />
        )}

        {step === 9 && (
          <Documentos
            item={protocolo}
            opcao={opcao}
            handleProximoStep={handleProximoStep}
            handleStepAnterior={handleStepAnterior}
          />
        )}
      </div>
    </>
  );
}
